$(document).on("turbo:load", function() {

  if ($("#client_bank_transaction_transaction_type_id").is(':visible')) {
    $("#client_bank_transaction_transaction_type_id").select2({placeholder: "取引種別..."});
  }

});

// #new_matter_transaction_type も data-for を持つので、#caller-id への記録は
// matters.js の [data-for] クリックハンドラが行う。
